(function()
{

	Object.defineProperty( Array.prototype,'iterate', {
		value : function(iter) {
			for (var i = 0, l = this.length; i < l; i++) {
				iter(i, this[i]);
			}
		}
	});


	Object.defineProperty( Array.prototype,'erase', {
		value : function(item) {
			var i = this.indexOf(item);
			if (i >= 0) this.splice(i, 1);
			return this;
		}
	});

	// Springroll already has random defined on Array, and will throw an error if this is
	// included.
	// Object.defineProperty(Array.prototype,'random', {
	// 	value : function() {
	// 		return this[ 0 | (Math.random() * this.length) ];
	// 	}
	// });

	Object.defineProperty(Array.prototype,'randomRotation', {
		value : function(chunk) {
			var l = this.length;
			if(l === 0) return null;
			if(chunk > l) chunk = l;
			var i = Math.floor(chunk * Math.random());
			var el = this.splice(i, 1)[0];
			this.push(el);
			return el;
		}
	});

	// Springroll already has this prop defined on Array, and will throw an error if this is
	// included.
	// Object.defineProperty(Array.prototype,'shuffle', {
	// 	value : function() {
	// 		var i = this.length, j, temp;
	// 		if ( i === 0 ) return this;
	// 		while ( --i ) {
	// 			j = Math.floor( Math.random() * ( i + 1 ) );
	// 			temp = this[i];
	// 			this[i] = this[j];
	// 			this[j] = temp;
	// 		}
	// 		return this;
	// 	}
	// });

	Object.defineProperty(Array.prototype, 'clone', {
		value : function() {
			return this.slice(0);
		}
	});

})();